module.exports = __webpack_public_path__ + "media/images/badge/tuttologo-4c70b13ecb02964df5367316e0ff1a05.png";